import React from 'react'

import CreatorSearchFilters from '@components/CreatorSearch/Filters/Filters'
import InboxFilters from '@components/Inbox/Filters'
import InboxMemberList from '@components/Inbox/Member/List'
import ReportsList from '@components/Reports/List/List'
import SideBar from '@components/UI/SideBar'

/**
 * Shared sidebar body for the campaign-scoped pages (Inbox, Audience
 * Reporting, Post Campaign Report, Creator Search) — they all compose the
 * same four sections (Submissions, Reports, Members, Creators) inside the
 * shared <SideBar>.
 *
 * BRAND-9307 task 6 (Ted design feedback, matches the prototype): the
 * Creators section (Vibe Check / List / Shortlisted) renders TOPMOST, above
 * Submissions.
 *
 * BRAND-9679: that order used to be conditional on the brief's `sourcing`
 * block, which the BE only serves to staff (brief_view's
 * render_sourcing_block? is `current_user_admin && ...`), so Brand Managers
 * fell through to the legacy order and saw Creators at the BOTTOM. The
 * section renders on `creator_sourcing_enabled` alone though (see Filters) —
 * BMs get the same List/Shortlisted tabs, just no staff-only Vibe Check — so
 * the ordering is now unconditional: when there is no Creators section to
 * place, CreatorSearchFilters renders nothing and the remaining three
 * sections keep their original order regardless.
 */
const CampaignSideBar: React.FC = () => (
  <SideBar>
    <CreatorSearchFilters />
    <InboxFilters />
    <ReportsList />
    <InboxMemberList />
  </SideBar>
)

export { CampaignSideBar }
export default CampaignSideBar
